
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insureyourcar/privacy-policy",
      function () {
        return require("private-next-pages/insureyourcar/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insureyourcar/privacy-policy"])
      });
    }
  